// generated by genversion
module.exports = '3.72.0';



//////////////////
// WEBPACK FOOTER
// ./src/utils/version.js
// module id = 1473
// module chunks = 0